// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","textLimit":"JUEhkbsTzkNVYcB_XX-JJ","overLimit":"_2OYQDIb7HS4Ap0XNewXMfv"};